import { pluralize } from '@travelata-libs/utils';
import type { ReviewAspect, ReviewSummaryPeriod } from '../model/types';

export const REVIEWS_WORD_FORMS = ['отзыва', 'отзыва', 'отзывов'];

export const PRAISED_TITLE = 'Хвалят';
export const CAVEATS_TITLE = 'Стоит учесть';

const getPeriodLabel = ({ from, to }: ReviewSummaryPeriod): string => {
  const [fromYear] = from.split('-');
  const [toYear] = to.split('-');
  return fromYear === toYear ? `за ${fromYear} год` : `за ${fromYear}–${toYear} годы`;
};

export const getReviewsCaption = (reviewsTotal: number, period: ReviewSummaryPeriod): string =>
  `На основе ${pluralize(REVIEWS_WORD_FORMS, reviewsTotal)} ${getPeriodLabel(period)}`;

export const addMentionsCaption = (aspect: ReviewAspect, reviewsTotal: number) => ({
  ...aspect,
  mentionsCaption: `${aspect.mentionsCount} из ${pluralize(REVIEWS_WORD_FORMS, reviewsTotal)}`,
});
